import { useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../constant/reportType";
import { Button, Form } from "react-bootstrap";
import { Switch, Table } from "antd";
import { ACCOUNT_CATEGORY_MASTER_COLUMN, ACCOUNT_MASTER_COLUMN, ACCOUNT_TYPE_MASTER_COLUMN, MEMBER_CATEGORY_MASTER_COLUMN, MEMBER_MASTER_COLUMN, SCENARIO_MASTER_COLUMN, SCRIPTURAL_REFERENCE_MASTER_COLUMN } from "../constant/AppConstant";
import { BsPencilSquare, BsPlus, BsSearch } from "react-icons/bs";
import MemberAccountingReportData from "./MemberAccountingReportData";
import { useDeleteMemberMasterMutation, useGetAllMemberMasterBySearchMutation, useGetAllMemberMasterMutation } from "../../redux-toolkit/services/MemberMasterService";
import { useDeleteMemberCategoryMasterMutation, useGetAllMemberCategoryMasterBySearchMutation, useGetAllMemberCategoryMasterMutation } from "../../redux-toolkit/services/MemberCategoryMasterService";
import { getMemberCategoryMasterBySearchDetails, getMemberCategoryMasterDetails, getMemberCategoryTotalRecords, setMemberCategoryMaster, setMemberCategoryMasterBySearch } from "../../redux-toolkit/slices/memberCategoryMasterSlice";
import { getMemberMasterBySearchDetails, getMemberMasterDetails, getMemberMasterTotalRecords, setMemberMaster, setMemberMasterBySearch } from "../../redux-toolkit/slices/memberMasterSlice";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import { alertMessage } from "../../utils/AlertService";
import { useDeleteAccountByIdMutation, useGetAllAccountWithPaginationMutation, useGetAllAccountWithSearchMutation } from "../../redux-toolkit/services/accountMasterService";
import { useDeleteAccountCategoryByIdMutation, useGetAllAccountCategoryWithPaginationMutation, useGetAllAccountCategoryWithSearchMutation } from "../../redux-toolkit/services/acountCategoryMasterServices";
import { getAccountCategoryDetailsBySearch, getAccountCategoryMasterDetails, getAccountCategoryMasterTotalRecords, setAccountCategoryBySearch, setAccountCategoryMaster } from "../../redux-toolkit/slices/accountCategoryMasterSlice";
import { getAccountDetailsBySearch, getAccountMasterDetails, getAccountMasterTotalRecords, setAccountBySearch, setAccountMaster } from "../../redux-toolkit/slices/accountMasterSlice";
import { useDeleteScenarioMasterMutation, useGetAllScenarioMastersMutation, useSearchScenarioMastersMutation } from "../../redux-toolkit/services/scenarioMasterService";
import { getScenarioMasterData, getScenarioMasterDataBySearch, getScenarioMasterTotalRecords, setScenarioMasters, setScenarioMastersBySearch } from "../../redux-toolkit/slices/scenarioMasterSlice";
import { useDeleteScripturalReferenceMutation, useGetAllScripturalReferencesMutation, useSearchScripturalReferencesMutation } from "../../redux-toolkit/services/scripturalReferenceMasterService";
import { getScripturalReferenceData, getScripturalReferenceDataBySearch, getScripturalReferenceTotalRecords, setScripturalReferences, setScripturalReferencesBySearch } from "../../redux-toolkit/slices/scripturalReferenceMasterSlice";
import { useSaveAuditLogMutation } from "../../redux-toolkit/services/auditLogService";
import { useDeleteAccountTypeMasterMutation, useGetAllAccountTypeMasterBySearchMutation, useGetAllAccountTypeMasterMutation } from "../../redux-toolkit/services/accountTypeMasterService";
import { getAccountTypeMasterBySearchDetails, getAccountTypeMasterDetails, getAccountTypeTotalRecords, setAccountTypeMaster, setAccountTypeMasterBySearch } from "../../redux-toolkit/slices/accountTypeMasterSlice";

type Props = {};
const MemberAccountingReports = (props: Props) => {

    const params = useParams();
    const localUserObj: any = getLocalStorageData("localUser");
    const token: any = getLocalStorageData("localUser").token;
    const dispatch = useDispatch();

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");

    //getMutations
    const [getAllMemberMaster, getAllMemberMasterResponse] = useGetAllMemberMasterMutation();
    const [getAllMemberCategoryMaster, getAllMemberCategoryMasterResponse] = useGetAllMemberCategoryMasterMutation();
    const [getAccountMasterWithPagination, getAccountMasterWithPaginationResponse] = useGetAllAccountWithPaginationMutation();
    const [getAccountCategoryMasterWithPagination, getAccountCategoryMasterWithPaginationResponse] = useGetAllAccountCategoryWithPaginationMutation();
    const [getAllScenarioMastersWithPagination, getAllScenarioMastersWithPaginationResponse] = useGetAllScenarioMastersMutation();
    const [getAllScripturalReferencesWithPagination, getAllScripturalReferencesWithPaginationResponse] = useGetAllScripturalReferencesMutation();
    const [getAllAccountTypeMasterWithPagination, getAllAccountTypeMasterWithPaginationResponse] = useGetAllAccountTypeMasterMutation()

    //get by search
    const [getAllMemberMasterBySearch, getAllMemberMasterBySearchResponse] = useGetAllMemberMasterBySearchMutation();
    const [getAllMemberCategoryMasterBySearch, getAllMemberCategoryMasterBySearchResponse] = useGetAllMemberCategoryMasterBySearchMutation();
    const [getAccountMasterBySearch, getAccountMasterBySearchResponse] = useGetAllAccountWithSearchMutation();
    const [getAccountCategoryMasterBySearch, getAccountCategoryMasterBySearchResponse] = useGetAllAccountCategoryWithSearchMutation();
    const [getScenarioMastersBySearch, getScenarioMastersBySearchResponse] = useSearchScenarioMastersMutation();
    const [getScripturalReferencesBySearch, getScripturalReferencesBySearchResponse] = useSearchScripturalReferencesMutation();
    const [getAccountTypeMasterBySearch, getAccountTypeMasterBySearchResponse] = useGetAllAccountTypeMasterBySearchMutation();

    //save
    const [logAudit] = useSaveAuditLogMutation();

    //delete mutation
    const [deleteMemberMaster, deleteMemberMasterResponse] = useDeleteMemberMasterMutation();
    const [deleteMemberCategoryMaster, deleteMemberCategoryMasterResponse] = useDeleteMemberCategoryMasterMutation();
    const [deleteAccountMaster, deleteAccountMasterResponse] = useDeleteAccountByIdMutation();
    const [deleteAccountCategoryMaster, deleteAccountCategoryMasterResponse] = useDeleteAccountCategoryByIdMutation();
    const [deleteScenarioMaster, deleteScenarioMasterResponse] = useDeleteScenarioMasterMutation()
    const [deleteScripturalReference, deleteScripturalReferenceResponse] = useDeleteScripturalReferenceMutation();
    const [deleteAccountTypeMaster, deleteAccountTypeMasterResponse] = useDeleteAccountTypeMasterMutation();

    //totalRecords
    const totalMemberCategoryMaster: any = useAppSelector(getMemberCategoryTotalRecords);
    const totalMemberMaster = useAppSelector(getMemberMasterTotalRecords);
    const totalAccountCategoryMaster: any = useAppSelector(getAccountCategoryMasterTotalRecords);
    const totalAccountMaster = useAppSelector(getAccountMasterTotalRecords);
    const totalScenarioMaster = useAppSelector(getScenarioMasterTotalRecords);
    const totalScripturalReference = useAppSelector(getScripturalReferenceTotalRecords);
    const totalAccountType = useAppSelector(getAccountTypeTotalRecords)

    //selector
    const memberMasterData: any = useAppSelector(getMemberMasterDetails);
    const memberMasterSearchData: any = useAppSelector(getMemberMasterBySearchDetails);
    const memberCategoryMasterData: any = useAppSelector(getMemberCategoryMasterDetails);
    const memberCategoryMasterSearchData: any = useAppSelector(getMemberCategoryMasterBySearchDetails);
    const accountMasterData: any = useAppSelector(getAccountMasterDetails);
    const accountMasterSearchData: any = useAppSelector(getAccountDetailsBySearch);
    const accountCategoryMasterData: any = useAppSelector(getAccountCategoryMasterDetails);
    const accountCategoryMasterSearchData: any = useAppSelector(getAccountCategoryDetailsBySearch);
    const scenarioMasterSearchData: any = useAppSelector(getScenarioMasterDataBySearch);
    const scenarioMasterData: any = useAppSelector(getScenarioMasterData);
    const scripturalReferenceSearchData: any = useAppSelector(getScripturalReferenceDataBySearch);
    const scripturalReferenceData: any = useAppSelector(getScripturalReferenceData);
    const accountTypeSearchData: any = useAppSelector(getAccountTypeMasterBySearchDetails);
    const accountTypeData: any = useAppSelector(getAccountTypeMasterDetails);
    

     
    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.MEMBER_MASTER:
                setReportName(REPORT_NAME.MEMBER_MASTER)
                break;
            case REPORT_PATH.MEMBER_CATEGORY_MASTER:
                setReportName(REPORT_NAME.MEMBER_CATEGORY_MASTER)
                break;
            case REPORT_PATH.ACCOUNT_CATEGORY_MASTER:
                setReportName(REPORT_NAME.ACCOUNT_CATEGORY_MASTER)
                break;
            case REPORT_PATH.ACCOUNT_MASTER:
                setReportName(REPORT_NAME.ACCOUNT_MASTER)
                break;
            case REPORT_PATH.ACCOUNT_TYPE_MASTER:
                setReportName(REPORT_NAME.ACCOUNT_TYPE_MASTER)
                break;
            case REPORT_PATH.SCENARIO_MASTER:
                setReportName(REPORT_NAME.SCENARIO_MASTER)
                break;
            case REPORT_PATH.SCRIPTURAL_REFERENCE_MASTER:
                setReportName(REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER)
                break;
            default:
        }
    }, [params.reportType]);

    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    // for delete switch button
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true ? "bg-accent" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isActive === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {record.status === true ||
                            record.enabled === true ||
                            record.isActive === true ? (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.MEMBER_MASTER && MEMBER_MASTER_COLUMN) {
            MEMBER_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.MEMBER_CATEGORY_MASTER && MEMBER_CATEGORY_MASTER_COLUMN) {
            MEMBER_CATEGORY_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.ACCOUNT_MASTER && ACCOUNT_MASTER_COLUMN) {
            ACCOUNT_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER && ACCOUNT_CATEGORY_MASTER_COLUMN) {
            ACCOUNT_CATEGORY_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
        else if (reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER && ACCOUNT_TYPE_MASTER_COLUMN) {
            ACCOUNT_TYPE_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
        else if (reportName === REPORT_NAME.SCENARIO_MASTER && SCENARIO_MASTER_COLUMN) {
            SCENARIO_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
        else if (reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER && SCRIPTURAL_REFERENCE_MASTER_COLUMN) {
            SCRIPTURAL_REFERENCE_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.MEMBER_MASTER) {
            getAllMemberMaster({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        } else if (reportName === REPORT_NAME.MEMBER_CATEGORY_MASTER) {
            getAllMemberCategoryMaster({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        } else if (reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER) {
            getAccountCategoryMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        } else if (reportName === REPORT_NAME.ACCOUNT_MASTER) {
            getAccountMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }
        else if (reportName === REPORT_NAME.SCENARIO_MASTER) {
            getAllScenarioMastersWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }
        else if (reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER) {
            getAllScripturalReferencesWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }
          else if (reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER) {
            getAllAccountTypeMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }

        
    }, [reportName]);

    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.MEMBER_MASTER) {
                getAllMemberMaster({
                    token: token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.MEMBER_CATEGORY_MASTER) {
                getAllMemberCategoryMaster({
                    token: token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.ACCOUNT_MASTER) {
                getAccountMasterWithPagination({
                    token: token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER) {
                getAccountCategoryMasterWithPagination({
                    token: token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            }
            else if (reportName === REPORT_NAME.SCENARIO_MASTER) {
                getAllScenarioMastersWithPagination({
                    token: token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            }

            else if (reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER) {
                getAllScripturalReferencesWithPagination({
                    token: token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            }
                else if (reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER) {
                getAllAccountTypeMasterWithPagination({
                    token: token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            }

            
        }
    }, [call]);

    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.MEMBER_MASTER) {
            getAllMemberMaster({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.MEMBER_CATEGORY_MASTER) {
            getAllMemberCategoryMaster({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER) {
            getAccountCategoryMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.ACCOUNT_MASTER) {
            getAccountMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        }
        else if (reportName === REPORT_NAME.SCENARIO_MASTER) {
            getAccountCategoryMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "asc"
                }
            });
        }
        else if (reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER) {
            getAllScripturalReferencesWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "asc"
                }
            });
        }
        else if (reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER) {
                getAllAccountTypeMasterWithPagination({
                    token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "asc"
                }
                });
            }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };

    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.MEMBER_MASTER) {
            deleteMemberMaster({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.MEMBER_MASTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

        } else if (reportName === REPORT_NAME.MEMBER_CATEGORY_MASTER) {
            deleteMemberCategoryMaster({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.MEMBER_CATEGORY_MASTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

        } else if (reportName === REPORT_NAME.ACCOUNT_MASTER) {
            deleteAccountMaster({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.ACCOUNT_MASTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

        } else if (reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER) {
            deleteAccountCategoryMaster({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.ACCOUNT_CATEGORY_MASTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

        } else if (reportName === REPORT_NAME.SCENARIO_MASTER) {
            deleteScenarioMaster({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.SCENARIO_MASTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

        } else if (reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER) {
            deleteScripturalReference({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
        }
        else if (reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER) {
            deleteAccountTypeMaster({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.ACCOUNT_TYPE_MASTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
        }
    };


    useEffect(() => {
        if (deleteMemberMasterResponse.isSuccess) {
            if (deleteMemberMasterResponse.data?.isActive) {
                alertMessage("Member Master enable successfully", "success");
            } else {
                alertMessage("Member Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteMemberMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteMemberMasterResponse.isSuccess, deleteMemberMasterResponse.isError]);

    useEffect(() => {
        if (deleteMemberCategoryMasterResponse.isSuccess) {
            if (deleteMemberCategoryMasterResponse.data?.isActive) {
                alertMessage("Member Category Master enable successfully", "success");
            } else {
                alertMessage("Member Category Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteMemberCategoryMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteMemberCategoryMasterResponse.isSuccess, deleteMemberCategoryMasterResponse.isError]);

    useEffect(() => {
        if (deleteAccountMasterResponse.isSuccess) {
            if (deleteAccountMasterResponse.data?.isActive) {
                alertMessage("Account Master enable successfully", "success");
            } else {
                alertMessage("Account Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteAccountMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteAccountMasterResponse.isSuccess, deleteAccountMasterResponse.isError]);

    useEffect(() => {
        if (deleteAccountCategoryMasterResponse.isSuccess) {
            if (deleteAccountCategoryMasterResponse.data?.isActive) {
                alertMessage("Account Category Master enable successfully", "success");
            } else {
                alertMessage("Account Category Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteAccountCategoryMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteAccountCategoryMasterResponse.isSuccess, deleteAccountCategoryMasterResponse.isError]);



    useEffect(() => {
        if (deleteScenarioMasterResponse.isSuccess) {
            if (deleteScenarioMasterResponse.data?.isActive) {
                alertMessage("Scenario Master enable successfully", "success");
            } else {
                alertMessage("Scenario Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteScenarioMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteScenarioMasterResponse.isSuccess, deleteScenarioMasterResponse.isError]);



    useEffect(() => {
        if (deleteScripturalReferenceResponse.isSuccess) {
            if (deleteScripturalReferenceResponse.data?.isActive) {
                alertMessage("Scriptural Reference Master enable successfully", "success");
            } else {
                alertMessage("Scriptural Reference Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteScripturalReferenceResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteScripturalReferenceResponse.isSuccess, deleteScripturalReferenceResponse.isError]);


     useEffect(() => {
        if (deleteAccountTypeMasterResponse.isSuccess) {
            if (deleteAccountTypeMasterResponse.data?.isActive) {
                alertMessage("Account Type Master enable successfully", "success");
            } else {
                alertMessage("Account Type Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteAccountTypeMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteAccountTypeMasterResponse.isSuccess, deleteAccountTypeMasterResponse.isError]);

    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    const handleSearch = (event: any) => {

        if (reportName === REPORT_NAME.MEMBER_MASTER) {
            getAllMemberMasterBySearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.MEMBER_CATEGORY_MASTER) {
            getAllMemberCategoryMasterBySearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.ACCOUNT_MASTER) {
            getAccountMasterBySearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER) {
            getAccountCategoryMasterBySearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        }
        else if (reportName === REPORT_NAME.SCENARIO_MASTER) {
            getScenarioMastersBySearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        }
        else if (reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER) {
            getScripturalReferencesBySearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        }
        else if (reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER) {
            getAccountTypeMasterBySearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        }
    };

    useEffect(() => {
        if (getAllMemberMasterBySearchResponse.isSuccess) {
            dispatch(setMemberMasterBySearch(getAllMemberMasterBySearchResponse));
        } else if (getAllMemberMasterBySearchResponse.isError) {
            let response: any = getAllMemberMasterBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllMemberMasterBySearchResponse.isSuccess, getAllMemberMasterBySearchResponse.isError]);

    useEffect(() => {
        if (getAllMemberCategoryMasterBySearchResponse.isSuccess) {
            dispatch(setMemberCategoryMasterBySearch(getAllMemberCategoryMasterBySearchResponse));
        } else if (getAllMemberCategoryMasterBySearchResponse.isError) {
            let response: any = getAllMemberCategoryMasterBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllMemberCategoryMasterBySearchResponse.isSuccess, getAllMemberCategoryMasterBySearchResponse.isError]);

    useEffect(() => {
        if (getAccountMasterBySearchResponse.isSuccess) {
            dispatch(setAccountBySearch(getAccountMasterBySearchResponse));
        } else if (getAccountMasterBySearchResponse.isError) {
            let response: any = getAccountMasterBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAccountMasterBySearchResponse.isSuccess, getAccountMasterBySearchResponse.isError]);

    useEffect(() => {
        if (getScenarioMastersBySearchResponse.isSuccess) {
            dispatch(setScenarioMastersBySearch(getScenarioMastersBySearchResponse));
        } else if (getScenarioMastersBySearchResponse.isError) {
            let response: any = getScenarioMastersBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getScenarioMastersBySearchResponse.isSuccess, getScenarioMastersBySearchResponse.isError]);



    useEffect(() => {
        if (getScripturalReferencesBySearchResponse.isSuccess) {
            dispatch(setScripturalReferencesBySearch(getScripturalReferencesBySearchResponse));
        } else if (getScripturalReferencesBySearchResponse.isError) {
            let response: any = getScripturalReferencesBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getScripturalReferencesBySearchResponse.isSuccess, getScripturalReferencesBySearchResponse.isError]);



    useEffect(() => {
        if (getAccountCategoryMasterBySearchResponse.isSuccess) {
            dispatch(setAccountCategoryBySearch(getAccountCategoryMasterBySearchResponse));
        } else if (getAccountCategoryMasterBySearchResponse.isError) {
            let response: any = getAccountCategoryMasterBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAccountCategoryMasterBySearchResponse.isSuccess, getAccountCategoryMasterBySearchResponse.isError]);


    useEffect(() => {
        if (getAllMemberMasterResponse.isSuccess) {
            dispatch(setMemberMaster(getAllMemberMasterResponse));
        } else if (getAllMemberMasterResponse.isError) {
            let response: any = getAllMemberMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllMemberMasterResponse.isSuccess, getAllMemberMasterResponse.isError]);

    useEffect(() => {
        if (getAllMemberCategoryMasterResponse.isSuccess) {
            dispatch(setMemberCategoryMaster(getAllMemberCategoryMasterResponse));
        } else if (getAllMemberCategoryMasterResponse.isError) {
            let response: any = getAllMemberCategoryMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllMemberCategoryMasterResponse.isSuccess, getAllMemberCategoryMasterResponse.isError]);

    useEffect(() => {
        if (getAccountMasterWithPaginationResponse.isSuccess) {
            dispatch(setAccountMaster(getAccountMasterWithPaginationResponse));
        } else if (getAccountMasterWithPaginationResponse.isError) {
            let response: any = getAccountMasterWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [getAccountMasterWithPaginationResponse.isSuccess, getAccountMasterWithPaginationResponse.isError]);

    useEffect(() => {
        if (getAccountCategoryMasterWithPaginationResponse.isSuccess) {
            dispatch(setAccountCategoryMaster(getAccountCategoryMasterWithPaginationResponse));
        } else if (getAccountCategoryMasterWithPaginationResponse.isError) {
            let response: any = getAccountCategoryMasterWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [getAccountCategoryMasterWithPaginationResponse.isSuccess, getAccountCategoryMasterWithPaginationResponse.isError]);

    useEffect(() => {
        if (getAllScenarioMastersWithPaginationResponse.isSuccess) {
            dispatch(setScenarioMasters(getAllScenarioMastersWithPaginationResponse));
        } else if (getAllScenarioMastersWithPaginationResponse.isError) {
            let response: any = getAllScenarioMastersWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllScenarioMastersWithPaginationResponse.isSuccess, getAllScenarioMastersWithPaginationResponse.isError]);


    useEffect(() => {
        if (getAllScripturalReferencesWithPaginationResponse.isSuccess) {
            console.log(getAllScripturalReferencesWithPaginationResponse, "getAllScripturalReferencesWithPaginationResponse");
            dispatch(setScripturalReferences(getAllScripturalReferencesWithPaginationResponse));
        } else if (getAllScripturalReferencesWithPaginationResponse.isError) {
            let response: any = getAllScripturalReferencesWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllScripturalReferencesWithPaginationResponse.isSuccess, getAllScripturalReferencesWithPaginationResponse.isError]);

      useEffect(() => {
        if (getAllAccountTypeMasterWithPaginationResponse.isSuccess) {
            console.log(getAllAccountTypeMasterWithPaginationResponse ,"getAllAccountTypeMasterWithPaginationResponse");
            dispatch(setAccountTypeMaster(getAllAccountTypeMasterWithPaginationResponse));
        } else if (getAllAccountTypeMasterWithPaginationResponse.isError) {
            let response: any = getAllAccountTypeMasterWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllAccountTypeMasterWithPaginationResponse.isSuccess, getAllAccountTypeMasterWithPaginationResponse.isError]);

    useEffect(() => {
        if (getAccountTypeMasterBySearchResponse.isSuccess) {
            dispatch(setAccountTypeMasterBySearch(getAccountTypeMasterBySearchResponse));
        } else if (getAccountTypeMasterBySearchResponse.isError) {
            let response: any = getAccountTypeMasterBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAccountTypeMasterBySearchResponse.isSuccess, getAccountTypeMasterBySearchResponse.isError]);

    useEffect(() => {
        if (memberMasterData && reportName === REPORT_NAME.MEMBER_MASTER) {
            setDatasource(memberMasterData);
        }
    }, [memberMasterData]);

    useEffect(() => {
        if (memberMasterSearchData && reportName === REPORT_NAME.MEMBER_MASTER) {
            setDatasource(memberMasterSearchData);
        }
    }, [memberMasterSearchData]);

    useEffect(() => {
        if (memberCategoryMasterData && reportName === REPORT_NAME.MEMBER_CATEGORY_MASTER) {
            setDatasource(memberCategoryMasterData);
        }
    }, [memberCategoryMasterData]);

    useEffect(() => {
        if (scripturalReferenceSearchData && reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER) {
            setDatasource(scripturalReferenceSearchData);
        }
    }, [scripturalReferenceSearchData]);

    useEffect(() => {
        if (accountTypeSearchData && reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER) {
            console.log(accountTypeSearchData ,"accountTypeSearchData");
            setDatasource(accountTypeSearchData);
        }
    }, [accountTypeSearchData]);

     useEffect(() => {
        if (memberCategoryMasterSearchData && reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER) {
            setDatasource(memberCategoryMasterSearchData);
        }
    }, [memberCategoryMasterSearchData]);



    useEffect(() => {
        if (accountMasterData && reportName === REPORT_NAME.ACCOUNT_MASTER) {
            setDatasource(accountMasterData);
        }
    }, [accountMasterData]);

    useEffect(() => {
        if (accountMasterSearchData && reportName === REPORT_NAME.ACCOUNT_MASTER) {
            setDatasource(accountMasterSearchData);
        }
    }, [accountMasterSearchData]);

    useEffect(() => {
        if (accountCategoryMasterData && reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER) {
            setDatasource(accountCategoryMasterData);
        }
    }, [accountCategoryMasterData]);

    useEffect(() => {
        if (accountCategoryMasterSearchData && reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER) {
            setDatasource(accountCategoryMasterSearchData);
        }
    }, [accountCategoryMasterSearchData]);


    useEffect(() => {
        if (scenarioMasterData && reportName === REPORT_NAME.SCENARIO_MASTER) {
            setDatasource(scenarioMasterData);
        }
    }, [scenarioMasterData]);

    useEffect(() => {
        if (scenarioMasterSearchData && reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER) {
            setDatasource(scenarioMasterSearchData);
        }
    }, [accountCategoryMasterSearchData]);

    useEffect(() => {
        if (scripturalReferenceData && reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER) {
            setDatasource(scripturalReferenceData);
        }
    }, [scripturalReferenceData]);

      useEffect(() => {
        console.log(accountTypeData ,"accountTypeData");
        if (accountTypeData && reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER) {
            console.log(accountTypeData ,"accountTypeData");
            setDatasource(accountTypeData);
        }
    }, [accountTypeData]);


    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-accent"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    <div className="d-flex flex-column">
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                onChange={handleSearch}
                            />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0">
                                    {/* <img src={gear} alt="" /> */}
                                    <BsSearch className=" bg-cm-light-primary1 border-cm-light-primary1" />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div onClick={handleShow} className="d-flex px-2 align-items-center mt-1">
                        <Button
                            className="d-flex align-items-center me-0 text-nowrap bg-accent"
                        // onClick={() => {
                        //     setActionType(ACTION_TYPE.ADD_ACTION);
                        // }}
                        >
                            <BsPlus />
                            Add
                        </Button>
                    </div>
                    {getAllMemberMasterResponse.isLoading ||
                        getAllMemberCategoryMasterResponse.isLoading ||
                        getAllMemberMasterBySearchResponse.isLoading ||
                        getAllMemberCategoryMasterBySearchResponse.isLoading ||
                        deleteMemberMasterResponse.isLoading ||
                        deleteMemberCategoryMasterResponse.isLoading ||
                        getAccountMasterWithPaginationResponse.isLoading ||
                        getAccountCategoryMasterWithPaginationResponse.isLoading ||
                        getAccountMasterBySearchResponse.isLoading ||
                        getAccountCategoryMasterBySearchResponse.isLoading ||
                        deleteAccountMasterResponse.isLoading ||
                        deleteAccountCategoryMasterResponse.isLoading ||
                        getAllScenarioMastersWithPaginationResponse.isLoading ||
                        getScenarioMastersBySearchResponse.isLoading ||
                        deleteScenarioMasterResponse.isLoading ||
                        getAllScripturalReferencesWithPaginationResponse.isLoading ||
                        getScripturalReferencesBySearchResponse.isLoading ||
                        deleteScripturalReferenceResponse.isLoading ? (
                        <Loading />
                    ) : (
                        ""
                    )}
                    {show && (
                        <MemberAccountingReportData
                            show={show}
                            setShow={setShow}
                            actionType={actionType}
                            reportName={reportName}
                            data={selectedRow}
                            setCall={setCall}
                        />
                    )}
                </div>
            </div>
            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}

                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.MEMBER_MASTER:
                                    return totalMemberMaster;
                                case REPORT_NAME.MEMBER_CATEGORY_MASTER:
                                    return totalMemberCategoryMaster;
                                case REPORT_NAME.ACCOUNT_MASTER:
                                    return totalAccountMaster;
                                case REPORT_NAME.ACCOUNT_CATEGORY_MASTER:
                                    return totalAccountCategoryMaster;
                                case REPORT_NAME.SCENARIO_MASTER:
                                    return totalScenarioMaster;
                                case REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER:
                                    return totalScripturalReference;
                                default:

                                    return [];
                            }
                        })(),
                        // hideOnSinglePage: true,  
                        responsive: true,
                        current: currentpage,
                        // showSizeChanger: true,  
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
        </div>
    );
};
export default MemberAccountingReports;